import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateANewUserType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class GetAllUserTypes extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/GetAll");
  }
}
class GetAUserType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/Get");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateAUserType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAUserType extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/Delete");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class GetRoleAccesses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/GetRoleAccess");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateRoleAccesses extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/UpdateRoleAccess");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetLoginUserAccess extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("UserType/GetLoginUserAccess");
  }
}

export {
  GetAllUserTypes,
  GetAUserType,
  CreateANewUserType,
  DeleteAUserType,
  UpdateAUserType,
  GetRoleAccesses,
  UpdateRoleAccesses,
  GetLoginUserAccess,
};
